(function ($) {
  'use strict';

  var collectionPriceRange = {
    debounceTimer: null,
    useNativeFilters: null,

    filterProductsClient: function (minVal, maxVal, minBound, maxBound) {
      minBound = minBound || 0;
      maxBound = maxBound || 999999999;
      var isDefault = minVal <= minBound && maxVal >= maxBound;
      var visible = 0;

      $('[data-price-min][data-price-max]').each(function () {
        var $item = $(this);
        var priceMin = parseInt($item.attr('data-price-min'), 10);
        var priceMax = parseInt($item.attr('data-price-max'), 10);
        var show = isDefault || (priceMax >= minVal && priceMin <= maxVal);
        $item.toggle(show);
        if (show) visible++;
      });

      collectionPriceRange.updateProductCount(visible, isDefault);
    },

    reapplyFromSliders: function () {
      $('.zct-price-range').each(function () {
        var $root = $(this);
        var $min = $root.find('.zct-price-range__input--min');
        var $max = $root.find('.zct-price-range__input--max');
        if (!$min.length) return;
        collectionPriceRange.filterProductsClient(
          parseInt($min.val(), 10),
          parseInt($max.val(), 10),
          parseInt($root.data('range-min'), 10),
          parseInt($root.data('range-max'), 10)
        );
      });
    },

    init: function () {
      var self = this;
      $('.zct-price-range').each(function () {
        self.bindRange($(this));
      });
    },

    bindRange: function ($root) {
      if ($root.data('zct-price-bound')) {
        return;
      }
      $root.data('zct-price-bound', true);

      var self = this;
      var minBound = parseInt($root.data('range-min'), 10) || 0;
      var maxBound = parseInt($root.data('range-max'), 10) || 100000;
      var $min = $root.find('.zct-price-range__input--min');
      var $max = $root.find('.zct-price-range__input--max');
      var $fill = $root.find('.zct-price-range__rail-active');
      var $outMin = $root.find('.zct-price-range__output--min');
      var $outMax = $root.find('.zct-price-range__output--max');
      var $reset = $root.find('.zct-price-range__reset');

      if (!$min.length || !$max.length) return;

      if (self.useNativeFilters === null) {
        self.useNativeFilters = $root.data('native-filters') === true || $root.data('native-filters') === 'true';
      }

      function formatMoney(cents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(
            cents,
            window.money_format || (window.Shopify && Shopify.money_format)
          );
        }
        return (cents / 100).toFixed(2);
      }

      function syncFill(minVal, maxVal) {
        var span = maxBound - minBound || 1;
        var left = ((minVal - minBound) / span) * 100;
        var width = ((maxVal - minVal) / span) * 100;
        $fill.css({ left: left + '%', width: width + '%' });
      }

      function updateOutputs(minVal, maxVal) {
        $outMin.text(formatMoney(minVal));
        $outMax.text(formatMoney(maxVal));
        syncFill(minVal, maxVal);
        var isDefault = minVal <= minBound && maxVal >= maxBound;
        $reset.prop('hidden', isDefault);
      }

      function readValues() {
        var minVal = parseInt($min.val(), 10);
        var maxVal = parseInt($max.val(), 10);
        if (minVal > maxVal) {
          minVal = maxVal;
          $min.val(minVal);
        }
        return { min: minVal, max: maxVal };
      }

      function buildFilterUrl(minVal, maxVal) {
        var params = {};
        var search = window.location.search.replace(/^\?/, '');

        if (search.length) {
          search.split('&').forEach(function (pair) {
            var parts = pair.split('=');
            if (parts.length > 1) {
              params[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1].replace(/\+/g, ' '));
            }
          });
        }

        if (minVal <= minBound && maxVal >= maxBound) {
          delete params['filter.v.price.gte'];
          delete params['filter.v.price.lte'];
        } else {
          params['filter.v.price.gte'] = String(minVal);
          params['filter.v.price.lte'] = String(maxVal);
        }

        collectionPriceRange.stripPriceTagsFromParams(params);

        var query = $.param(params).replace(/%2B/g, '+');
        return window.location.pathname + (query ? '?' + query : '');
      }

      function applyFilter(minVal, maxVal) {
        var coll = window.collection;
        var isDefault = minVal <= minBound && maxVal >= maxBound;

        collectionPriceRange.filterProductsClient(minVal, maxVal, minBound, maxBound);

        if (coll && typeof coll.filterAjaxClick === 'function') {
          coll.filterParams();
          if (isDefault) {
            delete Shopify.queryParams['filter.v.price.gte'];
            delete Shopify.queryParams['filter.v.price.lte'];
          } else {
            Shopify.queryParams['filter.v.price.gte'] = minVal;
            Shopify.queryParams['filter.v.price.lte'] = maxVal;
          }
          collectionPriceRange.stripPriceTagsFromConstraint();
          coll.filterAjaxClick();
          return;
        }

        var newUrl = buildFilterUrl(minVal, maxVal);
        if (window.History && History.pushState) {
          History.pushState({ param: {} }, newUrl, newUrl);
        } else {
          window.history.pushState({}, '', newUrl);
        }

        $.get(newUrl, function (data) {
          if (coll && typeof coll.filterMapData === 'function') {
            coll.filterMapData(data);
            collectionPriceRange.init();
          } else {
            collectionPriceRange.replaceProductsFromHtml(data);
          }
          collectionPriceRange.filterProductsClient(minVal, maxVal, minBound, maxBound);
        });
      }

      function scheduleApply() {
        clearTimeout(self.debounceTimer);
        self.debounceTimer = setTimeout(function () {
          var v = readValues();
          updateOutputs(v.min, v.max);
          applyFilter(v.min, v.max);
        }, 400);
      }

      $min.on('input.zctPrice change.zctPrice', function () {
        var minVal = parseInt($min.val(), 10);
        var maxVal = parseInt($max.val(), 10);
        if (minVal > maxVal) {
          $max.val(minVal);
        }
        updateOutputs(parseInt($min.val(), 10), parseInt($max.val(), 10));
        scheduleApply();
      });

      $max.on('input.zctPrice change.zctPrice', function () {
        var minVal = parseInt($min.val(), 10);
        var maxVal = parseInt($max.val(), 10);
        if (maxVal < minVal) {
          $min.val(maxVal);
        }
        updateOutputs(parseInt($min.val(), 10), parseInt($max.val(), 10));
        scheduleApply();
      });

      $reset.on('click.zctPrice', function () {
        $min.val(minBound);
        $max.val(maxBound);
        updateOutputs(minBound, maxBound);
        applyFilter(minBound, maxBound);
      });

      updateOutputs(parseInt($min.val(), 10), parseInt($max.val(), 10));

      var search = window.location.search;
      if (search.indexOf('filter.v.price.') !== -1) {
        var v = readValues();
        collectionPriceRange.filterProductsClient(v.min, v.max, minBound, maxBound);
      }
    },

    stripPriceTagsFromConstraint: function () {
      if (!Shopify.queryParams || !Shopify.queryParams.constraint) return;
      collectionPriceRange.stripPriceTagsFromParams(Shopify.queryParams);
    },

    stripPriceTagsFromParams: function (params) {
      if (!params.constraint) return;
      var tags = params.constraint.split('+');
      var kept = tags.filter(function (tag) {
        return tag.indexOf('$') === -1 && tag.toLowerCase().indexOf('price') === -1;
      });
      if (kept.length) {
        params.constraint = kept.join('+');
      } else {
        delete params.constraint;
      }
    },

    updateProductCount: function (visible, isDefault) {
      var label = visible === 1 ? 'Product' : 'Products';
      var text = isDefault ? null : visible + ' ' + label;

      if (text !== null) {
        $('.zct-filter-header__sub').text(text + ' shown');
        $('.zct-hero-count').text(text);
      }
    },

    replaceProductsFromHtml: function (data) {
      var $data = $(data);
      var $grid = $data.find('.grid-uniform');
      var $list = $data.find('.product-list-view');

      if ($grid.length) {
        $('.grid-uniform').replaceWith($grid.first());
      }
      if ($list.length) {
        $('.product-list-view').replaceWith($list.first());
      }
      if ($data.find('.pagination').length) {
        $('.pagination').replaceWith($data.find('.pagination').first());
      }
      var $sidebar = $data.find('.filter-to-left .engoj-collection-sidebar');
      if ($sidebar.length) {
        $('.filter-to-left .engoj-collection-sidebar').replaceWith($sidebar.first());
      }
    },
  };

  $(document).ready(function () {
    collectionPriceRange.init();
  });

  $(document).on('shopify:section:load', function () {
    collectionPriceRange.init();
  });

  window.collectionPriceRange = collectionPriceRange;
})(jQuery);
